import React, { useEffect, useState } from "react";
import { useLocation,useNavigate } from "react-router-dom";
import axios from "axios";
import "./AnticipationResult.css";

const AnticipationResult = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const results = location.state?.results || [];
  const backendScore = location.state?.score;

  const [leaderboard, setLeaderboard] = useState([]);
  const [userRank, setUserRank] = useState(null);
  

  const avgDistance = results.length
    ? (results.reduce((s, r) => s + parseFloat(r.DistanceError), 0) / results.length).toFixed(2)
    : 0;

  const avgTime = results.length
    ? (results.reduce((s, r) => s + r.TimeError, 0) / results.length).toFixed(2)
    : 0;


// after API call

  
  const fetchLeaderboard = async () => {
    try {
      const email = localStorage.getItem("rg_email");

      const res = await axios.get(`/anticipationleaderboard?email=${email}`);

      setLeaderboard(res.data.leaderboard || []);
      setUserRank(res.data.userRank);

    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchLeaderboard();
  }, []);

  return (
    <div className="result-big-container">

      {/* LEADERBOARD */}
      <div className="leaderboard-box">

        <h3>Leaderboard</h3>

        <table>
          <thead>
            <tr>
              <th>Rank</th>
              <th>Name</th>
              <th>Score</th>
              <th>Medal</th>
            </tr>
          </thead>

          <tbody>
            {leaderboard.slice(0, 5).map((p, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>{p.name}</td>
                <td>{p.score > 0 ? p.score : "-"}</td>
                <td>{["🥇", "🥈", "🥉"][i] || ""}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {userRank && (
          <div className="your-rank-box">
            Rank: {userRank.rank} <br />
            Score: {backendScore} <br />  
           
          </div>
        )}


      </div>

      {/* RESULT */}
      <div className="results-box">

        <h2>Your Result</h2>
        
        Score: {backendScore} <br />  
        <p>Avg Distance Error: {avgDistance} cm</p>
        <p>Avg Time Error: {avgTime}s</p>

        <button
            onClick={() => 
              navigate("/anticipation/play")}>
            Try Again
          </button>
        <button onClick={() => navigate("/anticipation")}>
          Exit
        </button>

      </div>

    </div>
  );
};

export default AnticipationResult;